import React from 'react';
import {Slot} from '../Slots';
import PropTypes from 'prop-types';
import Centrifuge from './centrifuge-top-empty.svg';
import {Image, Colours} from '@learningblocks/storybook-components';
import Unbalanced from '@learningblocks/exp-constants/lib/Icons/alert-large-fail';
import Balanced from '@learningblocks/exp-constants/lib/Icons/alert-large-success';

import Rotor from './rotor-top.svg';
import Solution from './solution-top.svg';
import RotorSolution from './rotor-solution-top.svg';

const IMAGE = {
  rotor: Rotor,
  solution: Solution,
  rotorSolution: RotorSolution,
};

export function BalanceTubesPanel(props) {
  const renderStatus = () => {
    let status = (
      <>
        <Unbalanced
          className={`${props.className}_status_icon`}
          fill={Colours.colorFeedbackFail}
        />
        <p className={`${props.className}_status_text`}>Not Balanced</p>
      </>
    );
    if (props.balanced) {
      status = (
        <>
          <Balanced
            className={`${props.className}_status_icon`}
            fill={Colours.colorFeedbackSuccess}
          />
          <p className={`${props.className}_status_text`}>Balanced</p>
        </>
      );
    }
    return status;
  };

  const renderSlot = (slot, key) => (
    <Slot
      key={key}
      id={key}
      rotor={slot.rotor}
      image={IMAGE}
      tubeType={slot.tubeType}
      solution={slot.solution}
      onTubeDrop={props.onTubeDrop}
      //contentDraggable={!props.balanced}
      className={`${props.className}_content_slots_${key}`}
    />
  );

  return (
    <div className={props.className}>
      <div className={`${props.className}_content`}>
        <div className={`${props.className}_content_slots`}>
          {props.slots.map(renderSlot)}
        </div>
        <Image
          className={`${props.className}_content_centrifuge`}
          src={Centrifuge}
          alt='centrifuge-top-view'
        />
      </div>
      <div className={`${props.className}_status`}>{renderStatus()}</div>
    </div>
  );
}

BalanceTubesPanel.propTypes = {
  /**
   * ClasssName to set on component
   */
  className: PropTypes.string,
  /**
   * Boolean to set if tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Funciton to invoke when a tube is dropped in a slot
   */
  onTubeDrop: PropTypes.func,
  /**
   * List of tubes in apparatus with its status.
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
};

BalanceTubesPanel.defaultProps = {};
